import { useCallback } from 'react';

import { useCopilot } from '../../CopilotContext';
import { useChatList } from './useChatList';

/**
 * Returns a handler that starts a fresh conversation — reusing an existing empty
 * chat when one is available so blank chats don't pile up. Shared by the panel
 * header's new-chat button and the ChatMenu dropdown.
 */
export function useNewChat(): () => void {
  const {
    conversationUuid,
    activeStudyUuid,
    switchConversation,
    createNewChat,
  } = useCopilot();
  const { chats } = useChatList();

  return useCallback(() => {
    const existingEmpty = chats.find((c) => c.messageCount === 0);
    if (existingEmpty) {
      if (existingEmpty.uuid !== conversationUuid) {
        switchConversation(existingEmpty.uuid);
      }
      return;
    }
    createNewChat(activeStudyUuid ?? undefined);
  }, [
    chats,
    conversationUuid,
    switchConversation,
    createNewChat,
    activeStudyUuid,
  ]);
}
